export default "__VITE_ASSET__fc9f8e33__"